var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-bbox": "30 32.5 140 135",
    "data-type": "color",
    viewBox: "30 32.5 140 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-m69434ay3__item-ker6vlz9 svg [data-color=&quot;1&quot;]{fill:#1d0e03}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b65e7",
    d: "M142.6 114.6 100 32.5 66.4 97.4l76.2 17.2z",
    "data-color": 1,
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b65e7",
    d: "m55.6 118.1 87.6-2.1-.6-1.4-76.2-17.2-10.8 20.7z",
    "data-color": 1,
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b65e7",
    d: "m49.7 129.3 94.3-11.8-.8-1.5-87.6 2.1-5.9 11.2z",
    "data-color": 1,
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b65e7",
    d: "m35.7 156.6 109.4-37.2-1.1-1.9-94.3 11.8-14 27.3z",
    "data-color": 1,
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b65e7",
    d: "M145.1 119.4 35.7 156.6 30 167.5h140",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickers);
export default __webpack_public_path__ + "static/media/stickers.e82e3e6c444f47cc2246f340a50054c2.svg";
export { ForwardRef as ReactComponent };